import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix, hasActivePlan, isFlash } = props;
  const images = listing.images;
  const { videoLinks } = listing?.attributes?.publicData || {};
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        videoLinks={hasActivePlan ? videoLinks : []}
        user={listing.author}
        listingId={listing.id?.uuid}
        viewImagesButtonMessageId={
          isFlash ? 'ListingImageGallery.viewImagesButtonFlash' : undefined
        }
        showThumbnails={!isFlash}
      />
    </section>
  );
};

export default SectionGallery;
